<template>
  <f7-popup
    class="gtu-popup"
    :opened="opened"
    @popup:close="close">
    <f7-page>
      <f7-navbar
        :title=" t('termsTitle') ">
        <f7-nav-right
          v-if="!err">
          <f7-link popup-close>{{ t('agree') }}</f7-link>
        </f7-nav-right>
      </f7-navbar>
      <f7-block>
        <div
          v-if="terms.text"
          v-html="terms.text" />
        <SystemInfo
          v-if="err"
          icon="error">
          {{ err }}
        </SystemInfo>
      </f7-block>
    </f7-page>
  </f7-popup>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { terms } from '@/services/atlastories'
export default {
  name: 'PopupGtu',
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      opened: this.open,
      err: '',
      terms: {
        version: 0,
        date: null,
        text: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      setting: 'global/setting'
    }),
    gtu () {
      return this.setting('gtu')
    }
  },
  watch: {
    open (val) {
      this.opened = val
    }
  },
  methods: {
    ...mapActions({
      setSetting: 'global/setSetting'
    }),
    close () {
      this.$db.gtu.clear()
      this.$db.gtu.put(this.terms).then(() => {
        this.setSetting({ gtu: this.terms.version })
        this.opened = false
        this.$emit('close')
      })
    },
    getGtu () {
      this.$db.gtu.get(1).then(doc => {
        if (doc) this.terms = doc
        this.getNewTerms()
      }).catch(err => {
        console.log(err)
        this.getNewTerms()
      })
    },
    getNewTerms () {
      terms(this.gtu).then(res => {
        const newTerms = res.data
        if (newTerms.version !== this.gtu) {
          this.terms = newTerms
          this.opened = true
        }
      }).catch(err => {
        console.log(err)
        this.err = err.message
      })
    }
  },
  created () {
    this.getGtu()
  }
}
</script>
